import ManufacturerService from './service';

export * from './reqres';

export default ManufacturerService;
